"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var Icon = styled_components_1.default(function (_a) {
  var SVGIcon = _a.icon,
      color = _a.color,
      size = _a.size,
      props = tslib_1.__rest(_a, ["icon", "color", "size"]);

  return react_1.default.createElement(SVGIcon, tslib_1.__assign({
    size: size
  }, props));
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (_a) {
  var color = _a.color,
      onClick = _a.onClick;
  return styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\t\tcolor: ", ";\n\t\t", ";\n\t"], ["\n\t\tcolor: ", ";\n\t\t", ";\n\t"])), color, onClick && styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t\t\tcursor: pointer;\n\t\t\t"], ["\n\t\t\t\tcursor: pointer;\n\t\t\t"]))));
});
Icon.defaultProps = {
  color: 'inherit',
  size: 16
};
exports.default = Icon;
var templateObject_1, templateObject_2, templateObject_3;